import { ThemeProvider } from '@emotion/react';
import { Box, Stack } from '@mui/material';
import React from 'react';
import { generateTheme } from '../themes';
import { RPMButton } from './subComponents/RPMButton';
import { RPMText } from './subComponents/RPMText';

const TextTwoCols = ({ sliceData }) => {
    // Destructuring the required fields from sliceData

    const {
        primary: {
            color_theme,
            headline1,
            body1,
            linktext1,
            link1,
            headline2,
            body2,
            linktext2,
            link2
        },
    } = sliceData;

    const theme = generateTheme(color_theme);

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, p: 0 }}>
                <Stack spacing={1} sx={{ flex: 1, p: { xs: 4, md: 12 }, mb: { xs: 0, md: 0 }, background: (theme) => theme.palette.background.default, justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                    <RPMText priscmicField={headline1} variant="h3" elementRenderType="h3" />
                    <RPMText priscmicField={body1} variant="p" elementRenderType="p" />
                    {link1.url &&
                        <RPMButton link={link1} linktext={linktext1} type="text" sx={{ marginTop: "2rem !important" }} />

                    }
                </Stack>
                <Stack spacing={1} sx={{ flex: 1, p: { xs: 4, md: 12 }, backgroundColor: "background.secondary", justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                    <RPMText priscmicField={headline2} variant="h3" elementRenderType="h3" />
                    <RPMText priscmicField={body2} variant="p" elementRenderType="p" />

                    {link2.url &&
                        <RPMButton link={link2} linktext={linktext2} type="contained" sx={{ marginTop: "2rem !important" }} />
                    }
                   
                </Stack>
            </Box>
        </ThemeProvider>
    );
};

export default TextTwoCols;